import type * as React from 'react';

import styled from 'styled-components';

import { Navigation } from './Navigation';
import { Version } from './Version';

interface Props {
  children: React.ReactNode;
}

const Wrapper = styled.div`
  width: 800px;
  margin: 50px auto 50px auto;
`;

export const Container = ({ children }: Props): JSX.Element => {
  return (
    <div>
      <Navigation />
      <Wrapper>
        <Version />
        <br />
        {children}
      </Wrapper>
    </div>
  );
};
